<template>
  <div id="app">
    <div class="app-wrap container">
      <NavBar />
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: { NavBar, Footer },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
#app {
  color: #2c3e50;
  overflow-x: hidden;
}
p {
  font-size: 1rem;
  font-weight: 600;
  text-align: left;
}
</style>
